import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { useToast } from '@/shared/hooks/use-toast';
import { clearQueryParam, getQueryParam } from '@/shared/lib/url';
import { Share2Icon } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Action } from '../action/action';

const { handleShowToast } = useToast.getState();

export const ShareAction = () => {
	const { state } = useConfigurator();

	useEffect(() => {
		const encodedData = getQueryParam('state');

		if (!encodedData) {
			return;
		}

		const decodedData = JSON.parse(atob(encodedData));
		useConfigurator.setState({ state: decodedData });

		clearQueryParam('state');
	}, []);

	const handleShare = () => {
		const encodedState = btoa(JSON.stringify(state));
		const url = `${window.location.href}?state=${encodedState}`;

		navigator.clipboard.writeText(url);

		handleShowToast(t('toast.url'));
	};

	const { t } = useTranslation();

	return (
		<Action
			tooltip={t('actions.share')}
			onClick={handleShare}
			icon={{
				component: Share2Icon,
			}}
		/>
	);
};
